import * as React from "react";
const SvgNextIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 9, viewBox: "0 0 5 9", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.94 0.852417L0 1.79242L3.05333 4.85242L0 7.91242L0.94 8.85242L4.94 4.85242L0.94 0.852417Z" }));
export default SvgNextIcon;
